import * as api from "./apiUtils";
const baseUrl = api.apiUrl + "profile";

//export async function getProfiles() {
//    return api.getAllAsync(baseUrl);
//}

export async function getProfile(userId) {
    return api.getAsync(baseUrl, userId);
}

export async function getMacros(userId) {
    return api.getAsync(`${baseUrl}/getmacros`, userId);
}

export async function addProfile(profile) {
    return api.postAsync(baseUrl, profile);
}

export async function updateProfile(userId, profile) {
    return api.putAsync(baseUrl, userId, profile);
}

//export async function deleteProfile(userId) {
//    return api.deleteAsync(baseUrl, userId);
//}
